function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "LANDING-DONACI\xD3N-SANGRE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-donacion-sangre",
  transform: "translate(-570.000000, -3062.000000)"
}, React.createElement("g", {
  id: "w3share",
  transform: "translate(105.000000, 2705.000000)"
}, React.createElement("g", {
  id: "follow-icons-1",
  transform: "translate(303.000000, 357.000000)"
}, React.createElement("g", {
  id: "instagram_icon",
  transform: "translate(162.000000, 0.000000)"
}, React.createElement("circle", {
  id: "circle",
  stroke: "#FFFFFF",
  cx: 19,
  cy: 19,
  r: 18.5
}), React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-instagram"
})), React.createElement("path", {
  d: "M19.0021194,14.12864 C16.3063023,14.12864 14.1318461,16.3035814 14.1318461,19 C14.1318461,21.6964186 16.3063023,23.87136 19.0021194,23.87136 C21.6979364,23.87136 23.8723926,21.6964186 23.8723926,19 C23.8723926,16.3035814 21.6979364,14.12864 19.0021194,14.12864 Z M19.0021194,22.16702 C17.2600112,22.16702 15.8358059,20.7467366 15.8358059,19 C15.8358059,17.2532634 17.2557724,15.83298 19.0021194,15.83298 C20.7484663,15.83298 22.1684328,17.2532634 22.1684328,19 C22.1684328,20.7467366 20.7442276,22.16702 19.0021194,22.16702 L19.0021194,22.16702 Z M25.2075851,13.9293763 C25.2075851,14.5610845 24.6989403,15.065603 24.0716118,15.065603 C23.4400446,15.065603 22.9356386,14.5568448 22.9356386,13.9293763 C22.9356386,13.3019078 23.4442833,12.7931496 24.0716118,12.7931496 C24.6989403,12.7931496 25.2075851,13.3019078 25.2075851,13.9293763 Z M28.4332404,15.0825616 C28.3611824,13.5605266 28.0136085,12.2123173 26.8988288,11.1015285 C25.7882878,9.99073971 24.4403793,9.64308825 22.9186838,9.56677452 C21.3503625,9.47774183 16.6496375,9.47774183 15.0813162,9.56677452 C13.5638595,9.6388486 12.2159509,9.98650006 11.1011712,11.0972889 C9.98639152,12.2080777 9.64305633,13.556287 9.56675962,15.078322 C9.47774679,16.6469932 9.47774679,21.3487672 9.56675962,22.9174384 C9.63881762,24.4394734 9.98639152,25.7876827 11.1011712,26.8984715 C12.2159509,28.0092603 13.5596207,28.3569117 15.0813162,28.4332255 C16.6496375,28.5222582 21.3503625,28.5222582 22.9186838,28.4332255 C24.4403793,28.3611514 25.7882878,28.0134999 26.8988288,26.8984715 C28.0093698,25.7876827 28.3569437,24.4394734 28.4332404,22.9174384 C28.5222532,21.3487672 28.5222532,16.6512328 28.4332404,15.0825616 Z M26.4071389,24.6005802 C26.0765198,25.4315519 25.4364752,26.0717394 24.6014501,26.4066719 C23.3510318,26.9027111 20.3839375,26.7882405 19.0021194,26.7882405 C17.6203012,26.7882405 14.6489682,26.8984715 13.4027886,26.4066719 C12.5720022,26.075979 11.9319576,25.4357916 11.5970998,24.6005802 C11.1011712,23.3498829 11.2156163,20.3821265 11.2156163,19 C11.2156163,17.6178735 11.1054099,14.6458775 11.5970998,13.3994198 C11.9277189,12.5684481 12.5677635,11.9282606 13.4027886,11.5933281 C14.6532069,11.0972889 17.6203012,11.2117595 19.0021194,11.2117595 C20.3839375,11.2117595 23.3552705,11.1015285 24.6014501,11.5933281 C25.4322365,11.924021 26.0722811,12.5642084 26.4071389,13.3994198 C26.9030675,14.6501171 26.7886224,17.6178735 26.7886224,19 C26.7886224,20.3821265 26.9030675,23.3541225 26.4071389,24.6005802 Z",
  id: "path-instagram",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/instagram.f26f39f5.svg";
export { SvgComponent as ReactComponent };